import { IconButton, Tokens, useModal } from "@homebound/beam";
import { useKey } from "react-use";
import { GlobalSearchModal } from "src/routes/layout/global-nav/GlobalSearchModal";

export function GlobalSearchBox() {
  const { openModal } = useModal();

  function open() {
    openModal({
      content: <GlobalSearchModal />,
      // Prevent the modal height by going up/down based on search results
      size: { height: 600, width: "lg" },
    });
  }

  // Look for command-o/control-o
  useKey(
    (event) => (event.metaKey || event.ctrlKey) && event.key === "o",
    (event) => {
      open();
      // Don't open the native file-open dialog
      event.preventDefault();
    },
    {},
    [],
  );

  const isMac = window.navigator.userAgent.indexOf("Mac") !== -1;
  return (
    <IconButton
      // Use a one-off button to be slimmer and match the navbar ux
      icon="search"
      onClick={open}
      color={Tokens.OnSurfaceMuted}
    />
  );
}
